module.exports = require("./fr-GN.js");